
















































































import Tabs from '@/components/Tabs.vue';
import CardReportElement from '@/components/cards/CardReportElement.vue';
import draggable from 'vuedraggable';
import { Component, Vue } from 'vue-property-decorator';
import { Form } from '@/models/Form';
import { Report, ReportElement, ReportElementType } from '@/models/ReportElement';
import { BDropdown, BDropdownItem, BOverlay } from 'bootstrap-vue';
import Editor from '@/components/Editor.vue';
import ModalVisibilityRuleSets from '@/components/modals/VisibilityRuleSets.vue';
import ModalFormConfig from '@/components/modals/ModalFormConfig.vue';
import { FormElementTag } from '@/models/FormElement';
import Jumbotron from '@/components/Jumbotron.vue';
import { mapGetters } from 'vuex';
import { User } from '@/models/User';
import { IReports } from '@/store/modules/report';

@Component({
    name: 'ReportElements',
    components: {
        draggable,
        'jumbotron': Jumbotron,
        'editor': Editor,
        'tabs': Tabs,
        'card-report-element': CardReportElement,
        'b-overlay': BOverlay,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'modal-visibility-rule-sets': ModalVisibilityRuleSets,
        'modal-form-config': ModalFormConfig,
    },
    computed: mapGetters({
        account: 'account/account',
        forms: 'forms/all',
        formElements: 'formElements/all',
        formElementTags: 'formElementTags/all',
        formElementTypes: 'formElementTypes/all',
        reports: 'reports/all',
        reportElementTypes: 'reportElementTypes/all',
    }),
})
export default class ReportElements extends Vue {
    loading = false;
    error = '';
    id!: number;
    input: any = {
        title: '',
        type: {},
        params: {},
    };

    // getters
    forms!: Form[];
    account!: User;
    formElementTags!: { [id: number]: FormElementTag[] };
    formElementTypes!: ReportElementType[];
    reports!: IReports;
    reportElementTypes!: ReportElementType[];

    get form(): Form | null {
        return this.forms.find((f: Form) => f.id === this.id) || null;
    }

    get report(): Report | null {
        if (!this.form) {
            return null;
        }
        return this.reports[this.form.uri];
    }

    async created() {
        this.loading = true;
        this.id = parseInt(this.$router.currentRoute.params.id, 10);

        try {
            await this.$store.dispatch('reports/read', this.id);
            await this.$store.dispatch('reportElementTypes/init');

            this.input.type = this.reportElementTypes[0];
        } catch (e) {
            this.error = e.toString();
        } finally {
            this.loading = false;
        }
    }

    async create() {
        if (this.form) {
            try {
                this.$store.dispatch('reports/create', this.form.uri);
            } catch (e) {
                this.error = e.toString();
            }
        }
    }

    async remove() {
        try {
            this.$store.dispatch('reports/delete', this.report);
        } catch (e) {
            this.error = e.toString();
        }
    }

    async add() {
        if (this.form && this.report) {
            try {
                const element = await this.$store.dispatch('reportElements/create', {
                    form: this.form.uri,
                    report: this.report.uri,
                    weight: this.report.elements.length,
                    type: this.input.type.uri,
                    title: this.input.title,
                    params: this.input.params,
                });
                this.$store.commit('reports/addElement', element);
                this.input = {
                    title: '',
                    type: this.input.type,
                    params: {},
                };
            } catch (e) {
                this.error = e.toString();
            }
        }
    }

    async onMove() {
        if (this.report) {
            const elements = this.report.elements;

            if (elements) {
                const data = elements.map((element: ReportElement, i: number) => {
                    return {
                        '@id': `/api/report_elements/${element.id}`,
                        '@type': 'ReportElement',
                        'weight': i,
                    };
                });

                await this.$store.dispatch('reports/update', { id: this.report.id, elements: data });
            }
        }
    }
}
